import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=2de51dea&scoped=true&"
import script from "./Household.vue?vue&type=script&lang=js&"
export * from "./Household.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de51dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de51dea')) {
      api.createRecord('2de51dea', component.options)
    } else {
      api.reload('2de51dea', component.options)
    }
    module.hot.accept("./Household.vue?vue&type=template&id=2de51dea&scoped=true&", function () {
      api.rerender('2de51dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/household/Household.vue"
export default component.exports